module.exports = __webpack_public_path__ + "assets/next-active.557370a7.svg";